import { useState } from "react";

import '../../../../styles/stepper.css'


const Page1 = ({ formData, setFormData, nextPage }) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.documentName) newErrors.documentName = "Document type is required.";

    if (!formData.documentNo) newErrors.documentNo = "Document No. is required.";

    if (!formData.pageNo) newErrors.pageNo = "Page No. is required.";

    if (!formData.bookNo) newErrors.bookNo = "Book No. is required.";

    
    if (formData.documentName?.toUpperCase()==="TITLE YOUR DOCUMENT" && !formData.documentTitle) newErrors.documentTitle = "Document title is required.";

    if (formData.requestFor?.toUpperCase()==="OTHER" && !formData.relationshipToBeneficiary) newErrors.relationshipToBeneficiary = "Relationship is required.";

    // QUESTIONS
    if (!formData.insidePhilippines) newErrors.insidePhilippines = "Answer is required.";

    if (!formData.question1) newErrors.question1 = "Answer is required.";

    if (!formData.question2) newErrors.question2 = "Answer is required.";

    if (!formData.question3) newErrors.question3 = "Answer is required.";

    if (!formData.question4) newErrors.question4 = "Answer is required.";

    setErrors(newErrors);

    // Scroll to the first invalid element
    setTimeout(() => {
    const firstInvalidElement = document.querySelector('.invalid-feedback');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalidElement.focus?.();
      }
    }, 0);

    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };
 
  const legalDocuments = [
    "Deed Of Donation",
    "Affidavit Of Loss",
    "Non-Disclosure Agreement",
    "Secretary's Certificate",
    "Title Your Document",
  ];

  const handleOnchangeRequesttFor = (e) => {
    let value = e.target.value;
    setFormData({ ...formData, requestFor: value});


    if(value.toUpperCase()==="SELF"){
        setFormData(({ relationshipToBeneficiary, ...rest }) => rest);
    }

  };
  const handleCertificate = (e) => {
    let value = e.target.value;
    setFormData({ ...formData, documentName: value});

    if(value.toUpperCase()==="TITLE YOUR DOCUMENT"){
        setFormData(({ documentTitle, ...rest }) => rest);
    }
  };



  return (
    <div className="step-content row">

      <div className="col-lg-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
          <div className="me-1">
            <h5 className="mb-1">Legal Document</h5>
            <p className="mb-1"><span className="fw-medium">Select and fill-up details.</span></p>
          </div>
          <div className="d-flex align-items-center d-none">
            <span className="badge bg-label-danger">UI/UX</span>
            <i className="bx bx-share-alt bx-sm mx-4" />
            <i className="bx bx-bookmarks bx-sm" />
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <label className="form-label text-info mb-1" htmlFor="sel_legal_document" >
              Document
            </label>

            <select
              id="sel_legal_document"
              className={`select2 form-select ${!formData.documentName && errors.documentName && 'is-invalid'}`}
              data-placeholder="Select Certificate"
              value={formData.documentName}
              name="document_name"
              onChange={handleCertificate}
            >
              <option value="">Select Legal Documents</option>
              {legalDocuments.map((document, index) => (
                <option key={index} value={document.toUpperCase()}>
                  {document}
                </option>
              ))}
            </select>
            {!formData.documentName && errors.documentName && <div className="invalid-feedback d-block blink">{errors.documentName}</div>}

          </div>

            {formData.documentName?.toUpperCase() === "TITLE YOUR DOCUMENT" && (
              <div className="col-md-6">
                  <label className="form-label text-info" htmlFor="txtDocumentTitle" >
                    Document Title
                  </label>
                  <input
                    type="text"
                    className={`form-control mt-n1 ${!formData.documentTitle && errors.documentTitle && 'is-invalid'}`}
                    id="txtDocumentTitle"
                    value={formData.documentTitle}
                    name="document_title"
                    placeholder="Enter title of your document"
                    aria-label="Document Title"
                    onChange={(e) => setFormData({ ...formData, documentTitle: e.target.value })}
                  />
                  {!formData.documentTitle && errors.documentTitle && <div className="invalid-feedback d-block blink">{errors.documentTitle}</div>}
                </div>
            )}

        

          


          <div className="col-md-6">
                <label className="form-label text-info" htmlFor="txtDocumentNo" >
                  Document No.
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.documentNo && errors.documentNo && 'is-invalid'}`}
                  id="txtDocumentNo"
                  value={formData.documentNo}
                  name="document_no"
                  placeholder="Enter Document No."
                  aria-label="Document No"
                  onChange={(e) => setFormData({ ...formData, documentNo: e.target.value })}
                />
                {!formData.documentNo && errors.documentNo && <div className="invalid-feedback d-block blink">{errors.documentNo}</div>}
          </div>

          <div className="col-md-6">
                <label className="form-label text-info" htmlFor="txtPageNo" >
                  Page No.
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.pageNo && errors.pageNo && 'is-invalid'}`}
                  id="txtPageNo"
                  value={formData.pageNo}
                  name="page_no"
                  placeholder="Enter Page No."
                  aria-label="Page No."
                  onChange={(e) => setFormData({ ...formData, pageNo: e.target.value })}
                />
                {!formData.pageNo && errors.pageNo && <div className="invalid-feedback d-block blink">{errors.pageNo}</div>}
          </div>

          <div className="col-md-6">
                <label className="form-label text-info" htmlFor="txtBookNo" >
                  Book No.
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.bookNo && errors.bookNo && 'is-invalid'}`}
                  id="txtBookNo"
                  value={formData.bookNo}
                  name="book_no"
                  placeholder="Enter Book No"
                  aria-label="Book No"
                  onChange={(e) => setFormData({ ...formData, bookNo: e.target.value })}
                />
                {!formData.bookNo && errors.bookNo && <div className="invalid-feedback d-block blink">{errors.bookNo}</div>}
          </div>

          <div className="col mt-4">
            <div className="row">
              <div className="col">
                <label className="form-label text-info" >
                  Are you requesting for your own or for someone else ?
                </label>
              </div>
              {
                formData.requestFor?.toLowerCase() === "other"  &&
                <div className={`${formData.documentName?.toUpperCase() === "TITLE YOUR DOCUMENT" ? 'd-none':'col-md-6'}`}>
                  <label className="form-label text-info" >
                    Select Relationship ?
                  </label>
                </div>
                }
            </div>
              

              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-6 d-flex flex-row mt-4 mb-2">
                    <div className="form-check">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="self"
                        checked={formData.requestFor === "self"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_1" >
                        Own Certificate
                      </label>
                    </div>
                    <div className="form-check ms-4">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="other"
                        checked={formData.requestFor === "other"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_2"
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_2" >
                        For someone else
                      </label>
                    </div>
                  </div>





                  {formData.requestFor?.toLowerCase() === "other" && (
                      <div className="col-md-6">
                        <select
                          id="sel_relationship"
                          className={`select2 form-select ${!formData.relationshipToBeneficiary && errors.relationshipToBeneficiary && 'is-invalid'}`}
                          data-placeholder="Relationship"
                          name="sel_relationship"
                          value={formData.relationshipToBeneficiary}
                          onChange={(e) => setFormData({ ...formData, relationshipToBeneficiary: e.target.value })}
                        >
                          <option value="">Select Relationship</option>
                          <option value="Mother">Mother</option>
                          <option value="Father">Father</option>
                          <option value="Spouse">Spouse</option>
                          <option value="Child">Child</option>
                          <option value="Sibling">Sibling</option>
                          <option value="Grandfather">Grandfather</option>
                          <option value="Grandmother">Grandmother</option>
                          <option value="Grandchild">Grandchild</option>
                          <option value="Aunt">Aunt</option>
                          <option value="Uncle">Uncle</option>
                          <option value="Nephew">Nephew</option>
                          <option value="Niece">Niece</option>
                          <option value="Cousin">Cousin</option>
                          <option value="Guardian">Guardian</option>
                          <option value="Foster Parent">Foster Parent</option>
                          <option value="Foster Child">Foster Child</option>
                          <option value="Step Parent">Step Parent</option>
                          <option value="Step Child">Step Child</option>
                          <option value="Adoptive Parent"> Adoptive Parent</option>
                          <option value="Adopted Child">Adopted Child</option>
                          <option value="Neighbor">Neighbor</option>
                        </select>
                        {!formData.relationshipToBeneficiary && errors.relationshipToBeneficiary && <div className="invalid-feedback d-block blink">{errors.relationshipToBeneficiary}</div>}
                      </div>
                    )}
                </div>
              </div>
          </div>

        </div>

      </div>


      <hr className="my-5"/>

      <div className="col-lg-12">
        <div className="content-header mb-3">
            <h5 className="mb-1">ANSWER EACH QUESTION TRUTHFULLY</h5>
            <p className="mb-1"><span className="fw-medium">your answers will reflect on your application.</span></p>
        </div>
 


        {/* QUESTION 0 */}
        <div class="list-group list-group-numbered">

          <div className="col-md-12 list-group-item d-flex">
            <div className="scroll-div col ">
              <div className="card-header">
                <span className="card-title  mb-2 fw-bold ms-2">
                  PRINCIPAL IS IN THE PHILIPPINES ?
                </span>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_inside_philippines"
                        className="form-check-input"
                        type="radio"
                        value="yes"
                        checked={formData.insidePhilippines === "yes"}
                        onChange={(e) => setFormData({ ...formData, insidePhilippines: e.target.value })}
                        defaultValue
                        id="rad_inside_philippines_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_inside_philippines_1" >
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_inside_philippines"
                        className="form-check-input"
                        type="radio"
                        value="no"
                        checked={formData.insidePhilippines === "no"}
                        onChange={(e) => setFormData({ ...formData, insidePhilippines: e.target.value })}
                        defaultValue
                        id="rad_inside_philippines_2"
                      />
                      <label className="form-check-label" htmlFor="rad_inside_philippines_2" >
                        No
                      </label>
                    </div>
                    {!formData.insidePhilippines && errors.insidePhilippines && <div className="invalid-feedback d-block blink">{errors.insidePhilippines}</div>}

                  </div>
                </div>
              </div>
            </div>
          </div>



          {/* QUESTION 1 */}
          <div className="col-md-12 list-group-item d-flex">
            <div className="col">
              <div className="card-header">
                <span className="card-title  mb-2 fw-bold ms-2">
                  WILL THE NOTARIZED DOCUMENT BE USED IN THE PHILIPPINES OR ABROAD ?
                </span>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_question"
                        className="form-check-input"
                        type="radio"
                        value="IN THE PHILIPPINES"
                        checked={formData.question1?.toUpperCase() === "IN THE PHILIPPINES"}
                        onChange={(e) => { setFormData({ ...formData, question1: e.target.value }) }}
                        defaultValue
                        id="rad_question1_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_question1_1" >
                        In the Philippines
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question"
                        className="form-check-input"
                        type="radio"
                        value="OUTSIDE THE PHILIPPINES"
                        checked={formData.question1 === "OUTSIDE THE PHILIPPINES"}
                        onChange={(e) => { setFormData({ ...formData, question1: e.target.value }) }}
                        defaultValue
                        id="rad_question1_2"
                      />
                      <label className="form-check-label" htmlFor="rad_question1_2" >
                        Outside the Philippines
                      </label>
                    </div>

                    {!formData.question1 && errors.question1 && <div className="invalid-feedback d-block blink">{errors.question1}</div>}


                  </div>
                </div>
              </div>
            </div>
          </div>



          {/* QUESTION 2 */}
          <div className="col-md-12 list-group-item d-flex">
            <div className="scroll-div col ">
              <div className="card-header">
                <span className="card-title  mb-2 fw-bold ms-2">
                  IS THE DOCUMENT SIGNED BY ALL SIGNATORIES BY HAND (WET-SIGNED) ?
                </span>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_question2"
                        className="form-check-input"
                        type="radio"
                        value="YES, THE DOCUMENT IS MANUALLY SIGNED BY ALL SIGNATORIES."
                        checked={formData.question2?.toUpperCase() === "YES, THE DOCUMENT IS MANUALLY SIGNED BY ALL SIGNATORIES."}
                        onChange={(e) => { setFormData({ ...formData, question2: e.target.value }) }}
                        defaultValue
                        id="rad_question2"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_question2" >
                        Yes, the document is manually signed by all signatories.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question2"
                        className="form-check-input"
                        type="radio"
                        value="NO, THE DOCUMENT IS ELECTRONICALLY/DIGITALLY SIGNED."
                        checked={formData.question2 === "NO, THE DOCUMENT IS ELECTRONICALLY/DIGITALLY SIGNED."}
                        onChange={(e) => { setFormData({ ...formData, question2: e.target.value }) }}
                        defaultValue
                        id="rad_question2_2"
                      />
                      <label className="form-check-label" htmlFor="rad_question2_2" >
                        No, the document is electronically/digitally signed.
                      </label>
                    </div>

                    {!formData.question2 && errors.question2 && <div className="invalid-feedback d-block blink">{errors.question2}</div>}


                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* QUESTION 3 */}
          <div className="col-md-12 list-group-item d-flex">
            <div className="col">
              <div className="card-header">
                <span className="card-title  mb-2 fw-bold ms-2">
                  WERE THE SIGNATORIES IN THE PHILIPPINES WHEN THEY SIGNED THE DOCUMENT ?
                </span>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_question3"
                        className="form-check-input"
                        type="radio"
                        value="YES, ALL SIGNATORIES WERE IN THE PHILIPPINES."
                        checked={formData.question3?.toUpperCase() === "YES, ALL SIGNATORIES WERE IN THE PHILIPPINES."}
                        onChange={(e) => { setFormData({ ...formData, question3: e.target.value }) }}
                        defaultValue
                        id="rad_question3_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_question3_1" >
                        Yes, all signatories were in the Philippines.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question3"
                        className="form-check-input"
                        type="radio"
                        value="NO, ALL SIGNATORIES WERE OUTSIDE THE PHILIPPINES."
                        checked={formData.question3 === "NO, ALL SIGNATORIES WERE OUTSIDE THE PHILIPPINES."}
                        onChange={(e) => { setFormData({ ...formData, question3: e.target.value }) }}
                        defaultValue
                        id="rad_question3_2"
                      />
                      <label className="form-check-label" htmlFor="rad_question3_2" >
                        No, all signatories were outside the Philippines.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question3"
                        className="form-check-input"
                        type="radio"
                        value="SOME WERE IN THE PHILIPPINES, AND SOME WERE OUTSIDE."
                        checked={formData.question3 === "SOME WERE IN THE PHILIPPINES, AND SOME WERE OUTSIDE."}
                        onChange={(e) => { setFormData({ ...formData, question3: e.target.value }) }}
                        defaultValue
                        id="rad_question3_3"
                      />
                      <label className="form-check-label" htmlFor="rad_question3_3" >
                        Some were in the Philippines, and some were outside.
                      </label>
                    </div>

                    {!formData.question3 && errors.question3 && <div className="invalid-feedback d-block blink">{errors.question3}</div>}


                  </div>
                </div>
              </div>
            </div>
          </div>



          {/* QUESTION 4 */}
          <div className="col-md-12 list-group-item d-flex">
            <div className="col">
              <div className="card-header">
                <span className="card-title  mb-2 fw-bold ms-2">
                  ARE THE SIGNATORIES CURRENTLY IN THE PHILIPPINES ?
                </span>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_question4"
                        className="form-check-input"
                        type="radio"
                        value="YES, ALL SIGNATORIES ARE IN THE PHILIPPINES."
                        checked={formData.question4?.toUpperCase() === "YES, ALL SIGNATORIES ARE IN THE PHILIPPINES."}
                        onChange={(e) => { setFormData({ ...formData, question4: e.target.value }) }}
                        defaultValue
                        id="rad_question4_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_question4_1" >
                        Yes, all signatories are in the Philippines.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question4"
                        className="form-check-input"
                        type="radio"
                        value="NO, ALL SIGNATORIES ARE OUTSIDE THE PHILIPPINES."
                        checked={formData.question4 === "NO, ALL SIGNATORIES ARE OUTSIDE THE PHILIPPINES."}
                        onChange={(e) => { setFormData({ ...formData, question4: e.target.value }) }}
                        defaultValue
                        id="rad_question4_2"
                      />
                      <label className="form-check-label" htmlFor="rad_question4_2" >
                        No, all signatories are outside the Philippines.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_question4"
                        className="form-check-input"
                        type="radio"
                        value="SOME ARE IN THE PHILIPPINES, AND SOME ARE OUTSIDE."
                        checked={formData.question4 === "SOME ARE IN THE PHILIPPINES, AND SOME ARE OUTSIDE."}
                        onChange={(e) => { setFormData({ ...formData, question4: e.target.value }) }}
                        defaultValue
                        id="rad_question4_3"
                      />
                      <label className="form-check-label" htmlFor="rad_question4_3" >
                        Some are in the Philippines, and some are outside.
                      </label>
                    </div>

                    {!formData.question4 && errors.question4 && <div className="invalid-feedback d-block blink">{errors.question4}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <div className="row g-4">
        <div className="col-12 d-flex justify-content-end">
          <button className="btn btn-primary btn-next" onClick={handleNext}>
            <span className="align-middle d-sm-inline-block d-none me-sm-1">
              Next
            </span>
            <i className="bx bx-chevron-right bx-sm me-sm-n2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Page1;
